export default __webpack_public_path__ + "static/media/480_business04-jp-web.13bede1a.png";